import { createSelector } from 'reselect'

export const getFormErrors = createSelector(
  (state) => state && state.user && state.user.auth && state.user.auth.formErrors ? state.user.auth.formErrors : null,
  (errors) => errors
)
